<template>
    <div class="tw-w-full tw-h-full tw-bg-white tw-rounded-lg tw-p-4 tw-border tw-border-solid tw-border-primary-200 tw-min-h-[600px]">
        <h1>Company Settings</h1>
    </div>
</template>

<script setup>

</script>

<style scoped>

</style>